<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" aria-label="بازگشت" title="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
      <div class="title-block">
        <h1 class="title">{{ definition.title }}</h1>
        <span class="muted">{{ subtitle | faNum }}</span>
      </div>
      <div class="actions">
        <button id="filterToggle" class="btn btn-ghost" type="button" [disabled]="loading"
          [attr.aria-expanded]="filtersOpen" aria-controls="routeSummaryFilters" (click)="toggleFilters()">
          <i class="fa fa-sliders"></i> فیلتر
          <span class="badge" [class.show]="hasOptionalFilters">{{ filterCount | faNum }}</span>
          <i class="fa fa-chevron-down chev"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="routeSummaryFilters" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <form class="filters" [formGroup]="form" (ngSubmit)="loadReport()">
          <div class="field">
            <span class="field-label">تاریخ شروع</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"
              [dateGregorianFormat]="'YYYY/MM/DD'" [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
              <input class="control" formControlName="strSDate" aria-label="تاریخ شروع">
            </ng-persian-datepicker>
          </div>
          <div class="field">
            <span class="field-label">تاریخ پایان</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"
              [dateGregorianFormat]="'YYYY/MM/DD'" [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
              <input class="control" formControlName="strEDate" aria-label="تاریخ پایان">
            </ng-persian-datepicker>
          </div>
          <label class="field">
            <span class="field-label">مسیر</span>
            <select class="control" formControlName="iRoute">
              <option [ngValue]="-1">همه مسیرها</option>
              <option *ngFor="let route of routes" [value]="route.iRoute">{{ route.strName | faNum }}</option>
            </select>
          </label>
          <label class="field">
            <span class="field-label">خودرو</span>
            <select class="control" formControlName="strUnitID">
              <option value="">همه خودروها</option>
              <option *ngFor="let vehicle of vehicles" [value]="vehicle.strUnitID">{{ vehicle.strFullName | faNum }}</option>
            </select>
          </label>
          <label class="field"><span class="field-label">برنامه مسیر</span><span><input type="checkbox" formControlName="bSchedule"> تنها موارد مطابق برنامه</span></label>
          <div class="filter-actions">
            <button class="btn btn-primary" type="submit" [disabled]="loading || !canSearch"><i class="fa fa-search"></i> جستجو</button>
            <button *ngIf="hasOptionalFilters" class="btn btn-ghost" type="button" [disabled]="loading" (click)="clearFilters()">
              <i class="fa fa-undo"></i> حذف فیلترها
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>
  <section class="card">
    <div class="table-toolbar">
      <label class="search-wrap">
        <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
          [placeholder]="searchPlaceholder" [disabled]="loading"><i class="fa fa-search"></i>
      </label>
      <div class="toolbar-actions">
        <button *ngIf="context.type !== '23'" class="btn btn-soft" type="button" ngxPrint [useExistingCss]="true"
          [printTitle]="definition.title" [printSectionId]="printSectionId" [disabled]="loading || hasError || !filteredRows.length">
          <i class="fa fa-print"></i> چاپ
        </button>
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" (click)="exportExcel()">
          <i class="fa fa-file-excel-o"></i> خروجی اکسل
        </button>
      </div>
    </div>
    <div class="body">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite"><div class="spinner"></div><span>در حال دریافت اطلاعات…</span></div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && !filteredRows.length">
        <div class="ico-big"><i class="fa fa-inbox"></i></div><h4>{{ emptyTitle }}</h4>
        <span class="muted" *ngIf="!hasRequestedData">بازه تاریخ و فیلترهای موردنظر را انتخاب و جستجو کنید.</span>
        <div class="empty-actions" *ngIf="hasSearch"><button class="btn btn-primary" type="button" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button></div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError">
        <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div><h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">{{ errorMessage }}</span>
        <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="retry()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
      </div>
      <div class="table-scroll" id="tableWrap" *ngIf="!loading && !hasError && filteredRows.length">
        <ng-container [ngTemplateOutlet]="reportTable" [ngTemplateOutletContext]="{ tableRows: pagedRows, offset: (currentPage - 1) * pageSize }"></ng-container>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length" [pageSizeOptions]="pageSizeOptions"
      (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
  </section>
  <div class="print-only" [id]="printSectionId" *ngIf="!loading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl"><h1 class="title">{{ definition.title }}</h1><span class="muted">{{ subtitle | faNum }}</span>
      <ng-container [ngTemplateOutlet]="reportTable" [ngTemplateOutletContext]="{ tableRows: filteredRows, offset: 0 }"></ng-container>
    </div>
  </div>
  <ng-template #reportTable let-tableRows="tableRows" let-offset="offset">
    <table>
      <thead><tr><th class="col-num">#</th><th *ngFor="let column of columns">{{ column.title }}</th></tr></thead>
      <tbody>
        <tr *ngFor="let row of tableRows; let index = index">
          <td class="col-num">{{ offset + index + 1 | faNum }}</td>
          <td *ngFor="let column of columns">
            <ng-container *ngIf="column.numeric; else textCell">{{ cellValue(row, column) | number:'1.0-2' | faNum }}</ng-container>
            <ng-template #textCell>{{ cellValue(row, column) | faNum }}</ng-template>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr><td>جمع کل</td><td *ngFor="let column of columns"><ng-container *ngIf="column.total">{{ totals[column.total] | number:'1.0-2' | faNum }} {{ column.unit }}</ng-container></td></tr>
        <tr><td class="label" [attr.colspan]="columns.length + 1">تعداد کل: {{ filteredRows.length | number | faNum }}</td></tr>
      </tfoot>
    </table>
  </ng-template>
</main>
